import React, { useState, useEffect } from "react";
import _ from "lodash";
import { SketchPicker } from "react-color";
import { hex, score } from "wcag-contrast";

import classes from "./utils.module.css";

//const isUrlSafe = (url) => {
//  return url.match(
//    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
//  );
//};

export const openLink = (event, link) => {
  event.preventDefault();
  //const url = isUrlSafe(decodeURIComponent(link));
  link = decodeURIComponent(link);
  const confirm = window.confirm(
    `Please confirm you want to open a new window at ${link}`
  );
  if (confirm) {
    link ? window.open(link) : alert(`Unable to open ${link} in a new window`);
  }
};

export const hexToRgb = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const ColorPicker = ({
  color,
  presetColors,
  onSelect,
  colorPickerType,
}) => {
  const [picker, openPicker] = useState(false);
  const [bgColor, setBgColor] = useState();

  useEffect(() => {
    setBgColor(color);
    if (colorPickerType === "rgb") {
      setBgColor(`rgb(${color})`);
    }
    if (colorPickerType === "nohex") {
      setBgColor(`#${color}`);
    }
  }, [color, colorPickerType]);

  return (
    <div className="color-picker">
      <div className={classes.swatch} onClick={() => openPicker(true)}>
        <div className={classes.color} style={{ background: `${bgColor}` }} />
      </div>
      {picker && (
        <div className={classes.popover}>
          <div className={classes.cover} onClick={() => openPicker(false)} />
          <SketchPicker
            disableAlpha={true}
            presetColors={presetColors}
            onChangeComplete={(col) => {
              let val = col.hex;
              if (colorPickerType) {
                val =
                  colorPickerType === "rgb"
                    ? `${col.rgb.r}, ${col.rgb.g}, ${col.rgb.b}`
                    : colorPickerType === "hex"
                    ? col.hex
                    : col.hex.slice(1);
              }
              onSelect(val);
            }}
            color={color}
          />
        </div>
      )}
    </div>
  );
};

export const ColorContrastView = ({ background, font }) => {
  if (!background || !font) return <span />;
  const ratio = hex(background, font);
  const level = score(ratio);
  return (
    <div className={`contrast-checker level-${level}`}>
      <span className="ratio">Ratio: {Math.round(ratio * 100) / 100}</span>
      <span className="level">Level: {level}</span>
    </div>
  );
};

export const getSelectors = async (banner, selectorMap) => {
  let images = [];
  Object.keys(banner).map((key) => {
    if (banner[key]) {
      if (banner[key].path && key !== "buylistHeader") {
        return images.push({ ...banner[key], key: key });
      }
    }
    return null;
  });
  images = images.sort((a, b) => {
    return parseInt(a.size.slice("x")) - parseInt(b.size.slice("x"));
  });
  let iconMap = [];
  await _.map(selectorMap, (icon) => {
    let index = _.findIndex(images, (image) => {
      return image.key === icon.key;
    });
    if (index !== -1) return (iconMap = [...iconMap, icon]);
  });
  return iconMap;
};

export const checkUser = (user, advertiser, retailer) => {
  if (user.restrictByAdvertiser) {
    if (
      !user.advertiser.find((item) => {
        return item === advertiser;
      })
    )
      return false;
  }
  if (user.restrictByRetailer && user.retailer !== retailer) return false;
  return true;
};
